// extracted by mini-css-extract-plugin
export default {"burger":"w0L6U"};